import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Card from '../../components/comman/CountCards';
import CountShimmer from '../../components/comman/CountCards/CountShimmer';
import cards from "./JSON/cards.json";
import { fetchCountries } from '../../redux/actions/chatbotActions/countryActions';
import { fetchCards } from '../../redux/actions/chatbotActions/cardActions';
import { fetchCategories } from '../../redux/actions/chatbotActions/categoryActions';
import { fetchChatbotOfferings } from '../../redux/actions/chatbotActions/offering.actions';

const CardSection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [counts, setCounts] = useState({
    chatbot: 0,
    category: 0,
    card: 0,
    country: 0,
  });

  const dispatch = useDispatch();

  const { chatbotCount, categoryCount, cardCount, countryCount, cardCountLoading } = useSelector(
    state => ({
      cardCount: state.cardReducer?.cards?.data?.length || 0,
      cardCountLoading: state.cardReducer?.loading || false,
      categoryCount: state.categoryReducer?.categories?.data?.length || 0,
      countryCount: state.countryReducer?.countries?.data?.length || 0,
      chatbotCount: state.chatBotReducers?.chatbotOfferings?.meta?.total || 0,
    }),
    shallowEqual
  );

  useEffect(() => {
    setCounts({
      chatbot: chatbotCount,
      category: categoryCount,
      card: cardCount,
      country: countryCount,
    });
  }, [chatbotCount, categoryCount, cardCount, countryCount]);

  // Compute active card from the current URL
  const getActiveCardId = () => {
    switch (location.pathname) {
      case "/chatbot-management":
        return "chatbot";
      case "/chatbot-management/category":
        return "category";
      case "/chatbot-management/card":
        return "card";
      case "/chatbot-management/country":
        return "country";
      default:
        return "";
    }
  };

  const activeCardId = getActiveCardId();

  const handleCardClick = (cardName) => {
    if (cardName === "chatbot") navigate(`/chatbot-management`);
    else navigate(`/chatbot-management/${cardName}`);
  };

  useEffect(() => {
    dispatch(fetchCountries(true));
    dispatch(fetchCards(true));
    dispatch(fetchCategories(true));
    dispatch(fetchChatbotOfferings());
  }, [dispatch]);

  return (
    <>
      {cardCountLoading ? (
        [...Array(4)].map((_, idx) => <CountShimmer key={idx} />)
      ) : (
        cards.map((card, index) => (
          <Card
            key={card.id}
            card={card}
            index={index}
            onClick={handleCardClick}
            count={counts[card.id]}
            isActive={activeCardId === card.id}
          />
        ))
      )}
    </>
  );
};

export default CardSection;
